import {useLang} from "../../../hooks";
import {useNotification} from "../../../hooks/useNotification";
import {useSocialSettings} from "../hooks/useSocialSettings";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {SocialSettingsSchema, socialSettingsSchema} from "../schema";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {InputValidationError} from "../../../libs/error";
import {Placeholder} from "rsuite";
import {Button, Form} from "react-bootstrap";

export function SocialSettings({onLanguageEdit}) {
  const {t} = useLang();
  const {notifyError,notifySuccess} = useNotification();
  const {settings, error, isLoading, save} = useSocialSettings();
  const {
    register,
    formState: {errors},
    setValue,
    handleSubmit,
    setError
  } = useForm({
    resolver: yupResolver(SocialSettingsSchema(t))
  });

  useEffect(() => {
    if (settings) {
      setValue("facebook", settings.facebook?.value);
      setValue("instagram", settings.instagram?.value);
      setValue("linkedin", settings.linkedin?.value);
      setValue("youtube", settings.youtube?.value);
      setValue("pinterest", settings.pinterest?.value);
      setValue("whatsapp", settings.whatsapp?.value);
      setValue("messenger", settings.messenger?.value);
      setValue("tiktok", settings.tiktok?.value);
      setValue("x", settings.x?.value);
    }
  }, [settings]);

  const navigate = useNavigate();
  if (error) {
    notifyError(error);
    navigate("/dashbaord");
  }

  const handleUpdate = async (data) => {
    try {
      await save(data);
      notifySuccess({
        title:"Success",
        message:"Social Settings Updated Successfully"
      })
    } catch (err) {
      if (err instanceof InputValidationError) {
        err.setRHFError(setError);
        notifyError({
          title: "Invalid input!",
          message: err.message
        });
        return;
      }
      notifyError({
        title: "Failed to update social settings!",
        message: err.message
      });
    }
  };

  return <section id="social-settings" className="my-4">
    <h2 className="mb-3">{t("social_settings_socialSettings")}</h2>
    {isLoading ? <Placeholder.Graph active /> :
      <Form className="d-flex flex-column gap-3" onSubmit={handleSubmit(handleUpdate)}>
        <Form.Group controlId="facebook">
          <Form.Label>{t("social_settings_facebook")}</Form.Label>
          <Form.Control
            {...register("facebook")}
            placeholder={t("social_settings_facebook_plhd")}
            type="url"
          />
          {errors.facebook?.message && (
            <Form.Text className="text-danger">
              {errors.facebook.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="instagram">
          <Form.Label>{t("social_settings_instagram")}</Form.Label>
          <Form.Control
            {...register("instagram")}
            placeholder={t("social_settings_instagram_plhd")}
            type="url"
          />
          {errors.instagram?.message && (
            <Form.Text className="text-danger">
              {errors.instagram.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="linkedin">
          <Form.Label>{t("social_settings_linkedin")}</Form.Label>
          <Form.Control
            {...register("linkedin")}
            placeholder={t("social_settings_linkedin_plhd")}
            type="url"
          />
          {errors.linkedin?.message && (
            <Form.Text className="text-danger">
              {errors.linkedin.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="youtube">
          <Form.Label>{t("social_settings_youtube")}</Form.Label>
          <Form.Control
            {...register("youtube")}
            placeholder={t("social_settings_youtube_plhd")}
            type="url"
          />
          {errors.youtube?.message && (
            <Form.Text className="text-danger">
              {errors.youtube.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="x">
          <Form.Label>{t("social_settings_x")}</Form.Label>
          <Form.Control
            {...register("x")}
            placeholder={t("social_settings_x_p")}
            type="url"
          />
          {errors.x?.message && (
            <Form.Text className="text-danger">
              {errors.x.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="pinterest">
          <Form.Label>{t("social_settings_pinterest")}</Form.Label>
          <Form.Control
            {...register("pinterest")}
            placeholder={t("social_settings_pinterest_p")}
            type="url"
          />
          {errors.pinterest?.message && (
            <Form.Text className="text-danger">
              {errors.pinterest.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="whatsapp">
          <Form.Label>{t("social_settings_whatsapp")}</Form.Label>
          <Form.Control
            {...register("whatsapp")}
            placeholder={t("social_settings_whatsapp_p")}
            type="url"
          />
          {errors.whatsapp?.message && (
            <Form.Text className="text-danger">
              {errors.whatsapp.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="tiktok">
          <Form.Label>{t("social_settings_tiktok")}</Form.Label>
          <Form.Control
            {...register("tiktok")}
            placeholder={t("social_settings_tiktok_p")}
            type="url"
          />
          {errors.tiktok?.message && (
            <Form.Text className="text-danger">
              {errors.tiktok.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="messenger">
          <Form.Label>{t("social_settings_messenger")}</Form.Label>
          <Form.Control
            {...register("messenger")}
            placeholder={t("social_settings_messenger_p")}
            type="url"
          />
          {errors.messenger?.message && (
            <Form.Text className="text-danger">
              {errors.messenger.message}
            </Form.Text>
          )}
        </Form.Group>

        <div className="d-flex justify-content-end gap-2">
          <Button className="px-4" variant="success" type="submit">
            {t("social_settings_save")}
          </Button>
        </div>
      </Form>
    }

  </section>;
}